enum SupportJumpPubSubEventEnum {
  PROVIDE_PASSWORD = 'PROVIDE_PASSWORD',
  PASSWORD_PROVIDED = 'PASSWORD_PROVIDED',
  INCORRECT_PASSWORD = 'INCORRECT_PASSWORD',
  PASSWORD_VERIFIED = 'PASSWORD_VERIFIED',
}

export default SupportJumpPubSubEventEnum;
